import leCount from './le-count.vue'

leCount.install = function (Vue) {
  Vue.component(leCount.name, leCount)
}

export default leCount
